import {Map} from 'immutable';

export interface KotlinPair<K, V> {
  first: K;
  second: V;
}

export default function pairsToMap<K, V>(pairs: Array<KotlinPair<K, V>>): Map<K, V> {
  return pairs.reduce<Map<K, V>>((acc, pair) => acc.set(pair.first, pair.second), Map());
}
